import React, { useEffect, useState } from "react";
import { ShieldAlert, Fingerprint, KeyRound, X } from "lucide-react";
import api from "../../api";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../context/LanguageContext";

const KEY = "lp-security-nudge-hidden";

// A shop account holds the deals, the pricing and the payment history. One stolen password
// shouldn't be enough to take it.
export const SecurityNudge = ({ onGoToSecurity }) => {
  const { t } = useLang();
  const { user } = useAuth();
  const [passkeys, setPasskeys] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");

  useEffect(() => {
    api.get("/passkeys").then((r) => setPasskeys((r.data?.passkeys || r.data || []).length || 0))
      .catch(() => setPasskeys(0));
  }, []);

  if (hidden || passkeys === null || user?.mfaEnabled || passkeys > 0) return null;

  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };

  return (
    <div className="rounded-2xl border border-[#f5b942] bg-[#fdf6e3] dark:bg-[#3a2f10] p-4" data-testid="security-nudge">
      <div className="flex items-start gap-3">
        <ShieldAlert size={18} className="text-[#b8860b] shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-foreground">{t("sec.nudgeTitle")}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{t("sec.nudgeBody")}</p>
          <div className="flex flex-wrap gap-2 mt-3">
            <button onClick={onGoToSecurity} data-testid="security-nudge-passkey-btn"
              className="inline-flex items-center gap-1.5 text-xs font-bold bg-[#0f2a1a] hover:bg-[#16341f] text-white px-3 py-2 rounded-xl transition-colors">
              <Fingerprint size={13} /> {t("sec.nudgePasskey")}
            </button>
            <button onClick={onGoToSecurity} data-testid="security-nudge-2fa-btn"
              className="inline-flex items-center gap-1.5 text-xs font-bold border border-border bg-card hover:border-[#16a34a] px-3 py-2 rounded-xl transition-colors">
              <KeyRound size={13} /> {t("sec.nudge2fa")}
            </button>
          </div>
        </div>
        <button onClick={dismiss} data-testid="security-nudge-dismiss"
          className="text-muted-foreground hover:text-foreground shrink-0" aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SecurityNudge;
